import { AuthorizeErrorCode } from './error-extensions';
const handledAuthorizeErrorCodes = [AuthorizeErrorCode.Apm, AuthorizeErrorCode.ThreeDs];
export const checkHasAuthorizeErrorToHandle = (errors) => {
    var _a, _b;
    const errorObject = errors === null || errors === void 0 ? void 0 : errors.find((error) => { var _a, _b; return ((_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code) && handledAuthorizeErrorCodes.includes((_b = error.extensions) === null || _b === void 0 ? void 0 : _b.code); });
    return {
        hasAuthorizeErrorToHandle: Boolean(errorObject),
        authUrl: (_a = errorObject === null || errorObject === void 0 ? void 0 : errorObject.extensions) === null || _a === void 0 ? void 0 : _a.url,
        supportsIframe: Boolean((_b = errorObject === null || errorObject === void 0 ? void 0 : errorObject.extensions) === null || _b === void 0 ? void 0 : _b.supportsIframe),
    };
};
//# sourceMappingURL=check-has-authorize-error-to-handle.js.map